import React from "react";
import { useNavigate } from "react-router-dom";
import { getUser } from "../../../utils/commonfunction";
import { ROLE } from "../../../utils/Constants";

function SuccessfullySubmitted() {
  const navigate = useNavigate();
  const userData = getUser(ROLE.USER);
  const isUserFlow = userData && userData.token && userData.role === ROLE.USER;

  return (
    <section className="py-12 lg:py-24">
      <div className="container">
        <div className="bg-white text-center p-[15px] md:p-[50px] rounded-[10px] max-w-[475px] shadow-[0px_2px_24px_rgba(0,0,0,0.05)] w-full mx-auto border border-zinc-100 flex flex-col items-center gap-[10px]">
          <img src="/images/tik1.png" alt="tik" />
          <h1 className="headings-h1">Successfully Submitted</h1>
          <p className="body-sm !leading-relaxed text-zinc-500">
            {isUserFlow
              ? "Your advertiser application has been submitted. An admin will review your profile and KYC details. You'll gain advertiser access once approved."
              : "Your profile and KYC details have been submitted for review. We'll notify you once verified."}
          </p>
          <div className="flex items-center gap-3 mt-[15px] flex-wrap justify-center">
            <button
              className="btn btn-pri min-w-[150px]"
              onClick={() => navigate("/")}
            >
              Go to Home
            </button>
            <button
              type="button"
              className="btn btn-outline min-w-[150px] border border-zinc-300 text-zinc-700 hover:bg-zinc-100"
              onClick={() => navigate("/advertiser/profile")}
            >
              Edit Details
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SuccessfullySubmitted;

